import { useCallback } from 'react';

import { JSONType } from '@/utils';

import { useCreateExport, UseCreateExportOpts } from './useCreateExport';

export const useCreateJSONExport = ({ agentId, runIds }: UseCreateExportOpts) => {
  const { createExport } = useCreateExport({ agentId, runIds });

  const create = useCallback(async () => {
    const json: JSONType = (await createExport()).filter((e) => e).map((e) => e.result);

    return new Blob([JSON.stringify(json, null, 2)], {
      type: 'application/json;charset=utf-8',
    });
  }, [createExport]);

  return { create };
};
